import React, { useContext, useState } from "react";
import { ISession } from "../../../../../types/dashboard";
import { formatDate1Session, formatDate2, formatTimeForInputValue } from "../../../../../utils/dateFormats";
import { Spinner } from "../../../../../components/spinner/Spinner";
import { DropDownButton, DropDownButtonColored } from "../../../../../components/dropDown/DropDownButton";
import { formatDateOnly, formatTimeOnly } from "../../../../../utils/timezone";
import "./FullSessionProgress.css";
import "./FullSessionItem.css";
import { AppContext } from "../../../../../appContext";

const VideoIcon = ()=><svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1.5C0 1.10218 0.206775 0.720644 0.574837 0.43934C0.942899 0.158035 1.4421 0 1.96262 0H7.85047C8.37099 0 8.87018 0.158035 9.23825 0.43934C9.60631 0.720644 9.81308 1.10218 9.81308 1.5V7.5C9.81308 7.89782 9.60631 8.27936 9.23825 8.56066C8.87018 8.84196 8.37099 9 7.85047 9H1.96262C1.4421 9 0.942899 8.84196 0.574837 8.56066C0.206775 8.27936 0 7.89782 0 7.5V1.5ZM11.6174 2.3295C11.4545 2.39174 11.3174 2.48743 11.2215 2.60586C11.1257 2.72428 11.0749 2.86075 11.0748 3V6C11.0749 6.13925 11.1257 6.27572 11.2215 6.39414C11.3174 6.51257 11.4545 6.60826 11.6174 6.6705L13.58 7.4205C13.7296 7.47762 13.8958 7.50459 14.0628 7.49884C14.2299 7.49309 14.3922 7.45481 14.5345 7.38765C14.6767 7.32048 14.7942 7.22664 14.8756 7.11505C14.9571 7.00345 14.9999 6.87779 15 6.75V2.25C14.9999 2.12221 14.9571 1.99655 14.8756 1.88495C14.7942 1.77336 14.6767 1.67952 14.5345 1.61235C14.3922 1.54519 14.2299 1.50691 14.0628 1.50116C13.8958 1.49541 13.7296 1.52238 13.58 1.5795L11.6174 2.3295Z"/>
</svg>

interface IFullSessionItemProps {
    data: ISession,
    progress: {current: number, total: number, isFailed: boolean, stage?: 'uploading' | 'uploaded' | 'failed'},
    isOpen?: boolean;
    onToggleOpen?: ()=>void;
    onUpload: () => void;
    onWatch: () => void;
    onEdit: ()=>void;
}

export const FullSessionItem = ({data, progress, isOpen: isOpenProp, onToggleOpen, onEdit, onUpload, onWatch}: IFullSessionItemProps) => {
    const [isOpenLocal, setOpenLocal] = useState(false);
    const isOpen = isOpenProp !== undefined ? isOpenProp : isOpenLocal;
    const setOpen = onToggleOpen || (() => setOpenLocal(prev => !prev));
    const { cheat, translate, currentLanguage } = useContext(AppContext);
    //console.log(data);

    //Logic to detect status by loaded video
    const getRealStatusOld = ()=>{
        const isStarting = data.Status === 'Processing';
        const isCreated = !data.Status || data.Error;
        if (data.status == 'Cancelled'){
            return 'Cancelled';
        }
        return (isStarting || isCreated) ? 'Upcoming': 'Finished'
    }

    //Logic to detect status by date
    const getRealStatus = ()=>{
        if (data.status == 'Cancelled'){
            return 'Cancelled';
        }
        
        // Use timezone-aware datetime for status calculation
        const sessionStart = data.startDatetime || data.date;
        if (sessionStart && new Date(sessionStart).valueOf() < Date.now()){
            return 'Finished'
        } else {
            return 'Upcoming'
        }
    }

    const testText = translate('session_no_description');
    const icon =  <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 1.5C0 1.10218 0.206775 0.720644 0.574837 0.43934C0.942899 0.158035 1.4421 0 1.96262 0H7.85047C8.37099 0 8.87018 0.158035 9.23825 0.43934C9.60631 0.720644 9.81308 1.10218 9.81308 1.5V7.5C9.81308 7.89782 9.60631 8.27936 9.23825 8.56066C8.87018 8.84196 8.37099 9 7.85047 9H1.96262C1.4421 9 0.942899 8.84196 0.574837 8.56066C0.206775 8.27936 0 7.89782 0 7.5V1.5ZM11.6174 2.3295C11.4545 2.39174 11.3174 2.48743 11.2215 2.60586C11.1257 2.72428 11.0749 2.86075 11.0748 3V6C11.0749 6.13925 11.1257 6.27572 11.2215 6.39414C11.3174 6.51257 11.4545 6.60826 11.6174 6.6705L13.58 7.4205C13.7296 7.47762 13.8958 7.50459 14.0628 7.49884C14.2299 7.49309 14.3922 7.45481 14.5345 7.38765C14.6767 7.32048 14.7942 7.22664 14.8756 7.11505C14.9571 7.00345 14.9999 6.87779 15 6.75V2.25C14.9999 2.12221 14.9571 1.99655 14.8756 1.88495C14.7942 1.77336 14.6767 1.67952 14.5345 1.61235C14.3922 1.54519 14.2299 1.50691 14.0628 1.50116C13.8958 1.49541 13.7296 1.52238 13.58 1.5795L11.6174 2.3295Z"/>
    </svg>

    const uploadButton = <div className={`button fullSessionItem_attachment`} onClick={(e)=>{
                e.stopPropagation();
                onUpload();
            }}>
        <div className="fullSessionItem_attachment_text">
            {translate('session_upload')}
        </div>
        <div className="fullSessionItem_attachment_icon">
            <VideoIcon></VideoIcon>
        </div>
    </div>

    const uploadWait = <div className="fullSessionItem_attachment_text fullSessionItem_attachment_wait">
        {progress && progress.isFailed ? translate('session_error') : translate('session_wait')}
    </div>

    const watchButton = <div className={`button fullSessionItem_attachment fullSessionItem_attachment_upload`} onClick={(e)=>{
            e.stopPropagation();
            onWatch();
        }}>
        <div className="fullSessionItem_attachment_text">
            {translate('session_watch')}
        </div>
        <div className="fullSessionItem_attachment_icon">
            <VideoIcon></VideoIcon>
        </div>
    </div>

    const getShownButton = ()=>{
        // Check if session has uploaded media (video file or prediction result)
        const hasMedia = data.video || data.PredictionID;
        
        // First check if analysis is still processing or not yet started - show wait message
        // Status must be explicitly set to something other than 'Processing' for watch to appear
        if (data.Status === 'Processing' || (hasMedia && !data.Status)) {
            return uploadWait;
        } else if (hasMedia && data.Status && data.Status !== 'Processing') {
            // If media exists AND status is set and not processing, show watch button
            return watchButton;
        } else if (progress && (progress.stage === 'uploading' || progress.stage === 'uploaded')) {
            return uploadWait;
        } else {
            return uploadButton;
        }
    }

    return (
        <div className={`fullSessionItem ${isOpen ? 'fullSessionItem--opened' : ''}`}>
            <div className="fullSessionItem_head" onClick={()=>setOpen()}>
                <div className="button fullSessionItem_edit_button" 
                    onClick={(e)=>{
                        e.stopPropagation();
                        onEdit();
                    }}
                >    
                </div>
                <div className="fullSessionItem_date">
                    {formatDateOnly(data.startDatetime || data.date, undefined, translate)}
                </div>
                <div className="fullSessionItem_time">
                    {formatTimeOnly(data.startDatetime || data.date, undefined, currentLanguage)}
                </div>
                <div className={`fullSessionItem_status ${{
                        Upcoming: '', 
                        Finished: 'fullSessionItem_status--finished', 
                        Cancelled: 'fullSessionItem_status--cancelled'
                    }[getRealStatus()] || ''}`}>
                    <div className="fullSessionItem_status_icon">

                    </div>
                    <div className="fullSessionItem_status_text">
                        {translate(`session_status_${getRealStatus().toLowerCase()}`)}
                    </div>
                </div>
                { 
                    progress && progress.current != progress.total ? (
                        <div className="fullSessionItem_progress">
                            <div className="fullSessionItem_progress_bar" style={{width: (progress.current / progress.total * 100) + '%', height: Math.min((progress.current / progress.total * 100 * 3.5), 100) + '%'}}>
                            </div>
                            <div className="fullSessionItem_progress_percent">
                                {progress && progress.isFailed ? translate('session_error') : 
                                Math.floor(progress.current / progress.total * 100) + '%'}
                            </div>

                        </div>
                    ) : (
                        getShownButton()
                    )
                }
                {/*<div className="debug button fullSessionItem_watch" onClick={onWatch}>Watch</div>*/}
                {/*<div className="button dashboard_main_block_open_button" onClick={()=>setOpen(last=>!last)}>

                </div>*/}
                {<DropDownButton isActive={!!(data as any)?.Summary} isOpen={isOpen} onChangeOpen={()=>{}}></DropDownButton>}
            </div>
            <div className="fullSessionItem_drop">
                <div className="fullSessionItem_drop_content">
                    <div className="fullSessionItem_drop_text" dangerouslySetInnerHTML={{__html: (data as any)?.Summary || testText}}>
                       {/*data?.Result?.output?.Summary || testText*/}
                    </div>
                    {cheat.debug && <div className="fullSessionItem_drop_menu">
                        <div className="button fullSessionItem_drop_button fullSessionItem_drop_button--analyze fullSessionItem_drop_button--active">
                            {translate('debug_analyze_session')}
                        </div>
                        <div className="button fullSessionItem_drop_button fullSessionItem_drop_button--watch">
                            {translate('debug_watch_video')}
                        </div>
                        <div className="button fullSessionItem_drop_button fullSessionItem_drop_button--add">
                            {translate('debug_add_task')}
                        </div>
                        <div className="button fullSessionItem_drop_button fullSessionItem_drop_button--chat">
                            {translate('debug_chat')}
                        </div>
                    </div>}
                </div>
            </div>
            {data.waitLoading ? <div className="fullSessionItem_loader_overlay"><Spinner></Spinner></div>: ""}
        </div>
    )
}